import React from 'react'
import { Route, Navigate, Routes } from 'react-router-dom'
import Form from './form'
import Confirmation from './success'

const RouteConfig = ({ product, productContent }) => {
  let defaultPath = product === 'countersketch' ? '/countersketch-webinar' : '/matrixgold-webinar'
  return (
    <Routes>
      <Route exact path='/matrixgold-webinar/confirmation' element={<Confirmation />} />
      <Route exact path='/matrixgold-webinar' element={<Form product={product} productContent={productContent} />} />
      <Route exact path='/countersketch-webinar/confirmation' element={<Confirmation />} />
      <Route exact path='/countersketch-webinar' element={<Form product={product} productContent={productContent} />} />
      <Route path='/' element={<Navigate to={defaultPath} />} />
      <Route path='*' element={<Navigate to={defaultPath} />} />
    </Routes>
  )
}

export default RouteConfig
